<template>
  <div class="imgs" @click="showImagePreview">
    <cube-scroll direction="horizontal" class="image-wrapper">
      <ul class="img-list">
        <li class="img-item"
            v-for="(img,index) in imgs"
            :key="index">
          <img :src="img+processor" :width="width" :height="width">
        </li>
      </ul>
    </cube-scroll>
  </div>
</template>

<script>
  export default {
    name: 'ImgList',
    props: {
      imgs: Array
    },
    computed: {
      processor() {
        if (this.imgs.length === 3) {
          return '?x-oss-process=style/240'
        } else if (this.imgs.length === 2) {
          return '?x-oss-process=style/360'
        } else if (this.imgs.length === 1) {
          return '?x-oss-process=style/480'
        } else {
          return ''
        }
      },
      width() {
        if (this.imgs.length === 3) {
          return 120
        } else if (this.imgs.length === 2) {
          return 180
        } else if (this.imgs.length === 1) {
          return 240
        } else {
          return 0
        }
      }
    },
    methods: {
      showImagePreview() {
        this.$createImagePreview({
          imgs: this.imgs
        }).show()
      }
    }
  }
</script>

<style lang="stylus" scoped>
  .imgs
    padding: 0 8px
    .image-wrapper
      display: flex
      align-items: center
      .cube-scroll-content /deep/
        display: inline-block
      .img-list
        white-space: nowrap
        .img-item
          display: inline-block
          margin-right: 6px
          &:last-child
            margin: 0
</style>
